import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import API from '../utils/api'
// import { Message } from 'element-ui'
import WebStorage from 'webStorage'
import utils from '../utils/utils'

// 首页
const index = resolve => require.ensure([],
  () => resolve(require('../pages/index/index')), 'index')
const indexSearch = resolve => require.ensure([],
  () => resolve(require('../pages/index/indexSearch/indexSearch')),
  'indexSearch')
// 资讯云
const routeConrtainer = resolve => require.ensure([],
  () => resolve(require('../components/routeContainer')), 'routeContainer')
const newsIndex = resolve => require.ensure([],
  () => resolve(require('../pages/news/index/newsIndex')), 'newsIndex')
const newsDetail = resolve => require.ensure([],
  () => resolve(require('../pages/news/newsDetail/newsDetail')), 'newsDetail')
const newsSearch = resolve => require.ensure([],
  () => resolve(require('../pages/news/newsSearch/newsSearch')), 'newsSearch')
const newsType = resolve => require.ensure([],
  () => resolve(require('../pages/news/newsType/newsType')), 'newsType')

// 政策
const policyIndex = resolve => require.ensure([],
  () => resolve(require('../pages/policy/policyIndex/policyIndex')),
  'policyIndex')
const policyType = resolve => require.ensure([],
  () => resolve(require('../pages/policy/policyType/policyType')), 'policyType')
const policyDetail = resolve => require.ensure([],
  () => resolve(require('../pages/policy/policyDetail/policyDetail')),
  'policyDetail')
const policyEngine = resolve => require.ensure([],
  () => resolve(require('../pages/policy/policyEngine/policyEngine')),
  'policyEngine')
const policyApply = resolve => require.ensure([],
  () => resolve(require('../pages/policy/policyApply/policyApply')),
  'policyApply')
const policyList = resolve => require.ensure([],
  () => resolve(require('../pages/policy/policyList/policyList')), 'policyList')
const applyEnter = resolve => require.ensure([],
  () => resolve(require('../pages/policy/applyEnter/applyEnter')), 'applyEnter')
const serviceSubsidy = resolve => require.ensure([],
  () => resolve(require('../pages/policy/serviceSubsidy/serviceSubsidy')),
  'serviceSubsidy')
const subsidyDetail = resolve => require.ensure([],
  () => resolve(require('../pages/policy/serviceSubsidy/subsidyDetail')),
  'subsidyDetail')
const subsidyApply = resolve => require.ensure([],
  () => resolve(require('../pages/policy/serviceSubsidy/subsidyApply')),
  'subsidyApply')

// 培训
const trainingIndex = resolve => require.ensure([],
  () => resolve(require('../pages/training/trainingIndex/trainingIndex')),
  'trainingIndex')
const trainingAdd = resolve => require.ensure([],
  () => resolve(require('../pages/training/trainingAdd/trainingAdd')),
  'trainingAdd')
const trainingSearch = resolve => require.ensure([],
  () => resolve(require('../pages/training/trainingSearch/trainingSearch')),
  'trainingSearch')
const trainingOrg = resolve => require.ensure([],
  () => resolve(require('../pages/training/trainingOrg/trainingOrg')),
  'trainingOrg')
const trainingDetail = resolve => require.ensure([],
  () => resolve(require('../pages/training/trainingDetail/trainingDetail')),
  'trainingDetail')

// 服务云
const serviceIndex = resolve => require.ensure([],
  () => resolve(require('../pages/service/serviceIndex/serviceIndex')),
  'serviceIndex')
const serviceOrgList = resolve => require.ensure([],
  () => resolve(require('../pages/service/serviceOrgList/serviceOrgList')),
  'serviceOrgList')
const serviceOrgDetail = resolve => require.ensure([],
  () => resolve(require('../pages/service/serviceOrgList/svceOrgDetail')),
  'serviceOrgDetail')
const serviceType = resolve => require.ensure([],
  () => resolve(require('../pages/service/serviceType/serviceType')),
  'serviceType')
const serviceUnit = resolve => require.ensure([],
  () => resolve(require('../pages/service/serviceUnit/serviceUnit')),
  'serviceUnit')
const serviceDetail = resolve => require.ensure([],
  () => resolve(require('../pages/service/serviceDetail/serviceDetail')),
  'serviceDetail')
const serviceApply = resolve => require.ensure([],
  () => resolve(require('../pages/service/serviceApply/serviceApply')),
  'serviceApply')
const demandsIndex = resolve => require.ensure([],
  () => resolve(require('../pages/service/demandsIndex/demandsIndex')),
  'demandsIndex')
const demandsType = resolve => require.ensure([],
  () => resolve(require('../pages/service/demandsType/demandsType')),
  'demandsType')
const demandsDetail = resolve => require.ensure([],
  () => resolve(require('../pages/service/demandsDetail/demandsDetail')),
  'demandsDetail')
const demandsUnit = resolve => require.ensure([],
  () => resolve(require('../pages/service/demandsUnit/demandsUnit')),
  'demandsUnit')
const demandsAdd = resolve => require.ensure([],
  () => resolve(require('../pages/service/demandsAdd/demandsAdd')),
  'demandsAdd')

// 产融
const industryIndex = resolve => require.ensure([],
  () => resolve(require('../pages/industry/industryIndex/industryIndex')),
  'industryIndex')
const financingProducts = resolve => require.ensure([],
  () => resolve(
    require('../pages/industry/financingProducts/financingProducts')),
  'financingProducts')
const financingProductsDetail = resolve => require.ensure([],
  () => resolve(require(
    '../pages/industry/financingProductsDetail/financingProductsDetail')),
  'financingProductsDetail')
const loanService = resolve => require.ensure([],
  () => resolve(require('../pages/industry/loanService/loanService')),
  'loanService')
const enterpriseProject = resolve => require.ensure([],
  () => resolve(
    require('../pages/industry/enterpriseProject/enterpriseProject')),
  'enterpriseProject')

// 创新
const innovationIndex = resolve => require.ensure([],
  () => resolve(require('../pages/innovation/innovationIndex/innovationIndex')),
  'innovationIndex')
const achievement = resolve => require.ensure([],
  () => resolve(require('../pages/innovation/achievement/achievement')),
  'achievement')
const achievementDetail = resolve => require.ensure([],
  () => resolve(require('../pages/innovation/achievement/achievementDetail')),
  'achievementDetail')
const patent = resolve => require.ensure([],
  () => resolve(require('../pages/innovation/patent/patent')),
  'patent')
const patentAdd = resolve => require.ensure([],
  () => resolve(require('../pages/innovation/patent/patentAdd')),
  'patentAdd')

const patentDetail = resolve => require.ensure([],
  () => resolve(require('../pages/innovation/patent/patentDetail')),
  'patentDetail')
const patentRightDetail = resolve => require.ensure([],
  () => resolve(
    require('../pages/innovation/patentRightDetail/patentRightDetail')),
  'patentRightDetail')
const rightsProtection = resolve => require.ensure([],
  () => resolve(
    require('../pages/innovation/patentRightDetail/rightsProtection')),
  'rightsProtection')

// 智库
const thinkTankIndex = resolve => require.ensure([],
  () => resolve(require('../pages/thinkTank/thinkTankIndex/thinkTankIndex')),
  'thinkTankIndex')
const expert = resolve => require.ensure([],
  () => resolve(require('../pages/thinkTank/expert/expert')),
  'expert')
const institution = resolve => require.ensure([],
  () => resolve(require('../pages/thinkTank/institution/institution')),
  'institution')
const institutionOrgDetail = resolve => require.ensure([],
  () => resolve(require('../pages/thinkTank/institution/institutionOrgDetail')),
  'institutionOrgDetail')
const tutor = resolve => require.ensure([],
  () => resolve(require('../pages/thinkTank/tutor/tutor')),
  'tutor')
const expertDetail = resolve => require.ensure([],
  () => resolve(require('../pages/thinkTank/expert/expertDetail')),
  'expertDetail')

// 政策
const companyIndex = resolve => require.ensure([],
  () => resolve(require('../pages/company/companyIndex/companyIndex')),
  'companyIndex')
const orgDetail = resolve => require.ensure([],
  () => resolve(require('../pages/company/ogrDetail/orgDetail')),
  'orgDetail')
// 企业产品详情
const productDetail = resolve => require.ensure([],
  () => resolve(require('../pages/account/companyProductList/detail')),
  'productDetail')

// 认证
const organizationIndex = resolve => require.ensure([],
  () => resolve(
    require('../pages/account/organizationIndex/organizationIndex')),
  'organizationIndex')
const serviceOrg = resolve => require.ensure([],
  () => resolve(require('../pages/account/serviceOrg/serviceOrg')),
  'serviceOrg')
const companyOrg = resolve => require.ensure([],
  () => resolve(require('../pages/account/companyOrg/companyOrg')),
  'companyOrg')
const orgUserList = resolve => require.ensure([],
  () => resolve(require('../pages/account/orgUserList/orgUserList')),
  'orgUserList')

// 账户
const signin = resolve => require.ensure([],
  () => resolve(require('../pages/account/signin')), 'signin')
const register = resolve => require.ensure([],
  () => resolve(require('../pages/account/register')), 'register')
const forget = resolve => require.ensure([],
  () => resolve(require('../pages/account/forget')), 'forget')
const personalInfo = resolve => require.ensure([],
  () => resolve(require('../pages/account/personalInfo/personalInfo')),
  'personalInfo')
const findPass = resolve => require.ensure([],
  () => resolve(require('../pages/account/findPass/findPass')),
  'findPass')
const policyApproval = resolve => require.ensure([],
  () => resolve(require('../pages/account/policyApproval/policyApproval')),
  'policyApproval')
const proDetailList = resolve => require.ensure([],
  () => resolve(require('../pages/account/policyApproval/proDetailList')),
  'proDetailList')
const formDetail = resolve => require.ensure([],
  () => resolve(require('../pages/account/policyApproval/formDetail')),
  'formDetail')
const myApply = resolve => require.ensure([],
  () => resolve(require('../pages/account/myApply/myApply')),
  'myApply')
const proList = resolve => require.ensure([],
  () => resolve(require('../pages/account/proList/proList')),
  'proList')
const mySubsidy = resolve => require.ensure([],
  () => resolve(require('../pages/account/mySubsidy/mySubsidy')),
  'mySubsidy')
const myTraining = resolve => require.ensure([],
  () => resolve(require('../pages/account/myTraining/myTraining')),
  'myTraining')
const myTrainingAdd = resolve => require.ensure([],
  () => resolve(require('../pages/account/myTraining/myTrainingAdd')),
  'myTrainingAdd')
const myTrainingDetail = resolve => require.ensure([],
  () => resolve(require('../pages/account/myTraining/myTrainingDetail')),
  'myTrainingDetail')
const myDemands = resolve => require.ensure([],
  () => resolve(require('../pages/account/myDemands/myDemands')),
  'myDemands')
const myDemandsAdd = resolve => require.ensure([],
  () => resolve(require('../pages/account/myDemands/myDemandsAdd')),
  'myDemandsAdd')
const companyProductList = resolve => require.ensure([],
  () => resolve(require('../pages/account/companyProductList/companyProductList')),
  'companyProductList')
const myDemandsDetail = resolve => require.ensure([],
  () => resolve(require('../pages/account/myDemands/myDemandsDetail')),
  'myDemandsDetail')
const myService = resolve => require.ensure([],
  () => resolve(require('../pages/account/myService/myService')),
  'myService')
const myServiceAdd = resolve => require.ensure([],
  () => resolve(require('../pages/account/myService/myServiceAdd')),
  'myServiceAdd')
const myServiceDetail = resolve => require.ensure([],
  () => resolve(require('../pages/account/myService/myServiceDetail')),
  'myServiceDetail')
const myRight = resolve => require.ensure([],
  () => resolve(require('../pages/account/myRight/myRight')),
  'myRight')
const myMessage = resolve => require.ensure([],
  () => resolve(require('../pages/account/myMessage/myMessage')),
  'myMessage')
const zhaobiao = resolve => require.ensure([],
  () => resolve(require('../pages/zhaoBiao/zhaobiao')),
  'zhaobiao')
const zhaobiaoDetail = resolve => require.ensure([],
  () => resolve(require('../pages/zhaoBiao/zhaobiaoDetail')),
  'zhaobiao')

const subsidyReportList = resolve => require.ensure([],
  () => resolve(require('../pages/account/subsidyReport/subsidyList')),
  'zhaobiao')
const subsidyApplyReportList = resolve => require.ensure([],
  () => resolve(require('../pages/account/subsidyReport/subsidyApplyList')),
  'zhaobiao')
const subsidyReportDetail = resolve => require.ensure([],
  () => resolve(require('../pages/account/subsidyReport/subsidyDetail')),
  'zhaobiao')

// 疫情
const yqpolicy = resolve => require.ensure([],
  () => resolve(require('../pages/yq/yqpolicy/index')), 'yqpolicy')
const zhunwu = resolve => require.ensure([],
  () => resolve(require('../pages/yq/zhuwu/index')), 'zhunwu')
const zwDetail = resolve => require.ensure([],
  () => resolve(require('../pages/yq/zhuwu/zwDetail')), 'zwDetail')
const yqDetail = resolve => require.ensure([],
  () => resolve(require('../pages/yq/yqDetail/yqDetail')), 'yqDetail')
const yqServer = resolve => require.ensure([],
  () => resolve(require('../pages/yq/yqServer/yqServer')), 'yqServer')
const yqNeed = resolve => require.ensure([],
  () => resolve(require('../pages/yq/yqNeed/yqNeed')), 'yqNeed')
const yqNeedDetail = resolve => require.ensure([],
  () => resolve(require('../pages/yq/yqNeed/yqNeedDetail')), 'yqNeedDetail')
const yqLive = resolve => require.ensure([],
  () => resolve(require('../pages/yq/yqLive/yqLive')), 'yqLive')
const yqZJ = resolve => require.ensure([],
  () => resolve(require('../pages/yq/yqZJ/zj')), 'yqZJ')
const yqTips = resolve => require.ensure([],
  () => resolve(require('../pages/yq/yqTips/yqTips')), 'yqTips')
const yqTipDetail = resolve => require.ensure([],
  () => resolve(require('../pages/yq/yqTips/yqTipDetail')), 'yqTipDetail')

// test
const test = resolve => require.ensure([],
  () => resolve(require('../pages/test/test')), 'test')

const compatible = resolve => require.ensure([],
  () => resolve(require('../pages/compatible')), 'compatible')

Vue.use(Router)

const router = new Router({
  scrollBehavior: () => ({ y: 0 }), // 路由跳转后页面回到顶部
  routes: [
    {
      path: '/',
      // name: 'HelloWorld',
      // component: HelloWorld
      redirect: '/index',
    }, {
      path: '/test',
      name: 'test',
      component: test,
    }, {
      path: '/compatible',
      name: 'compatible',
      component: compatible,
    }, {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        title: '遂企云•首页',
      },
    }, {
      path: '/indexSearch',
      name: 'indexSearch',
      component: indexSearch,
      meta: {
        title: '遂企云•搜索',
      },
    }, {
      path: '/signin',
      name: 'signin',
      component: signin,
      meta: {
        title: '遂企云•用户登录',
      },
    }, {
      path: '/register',
      name: 'register',
      component: register,
      meta: {
        title: '遂企云•用户注册',
      },
    }, {
      path: '/forget',
      name: 'forget',
      component: forget,
      meta: {
        title: '遂企云•找回密码',
      },
    }, {
      path: '/personIndex',
      name: 'personIndex',
      component: routeConrtainer,
      children: [
        {
          path: 'personalInfo',
          name: 'personalInfo',
          component: personalInfo,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'findPass',
          name: 'findPass',
          component: findPass,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'policyApproval',
          name: 'policyApproval',
          component: policyApproval,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'proDetailList',
          name: 'proDetailList',
          component: proDetailList,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'formDetail',
          name: 'formDetail',
          component: formDetail,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'myApply',
          name: 'myApply',
          component: myApply,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'proList',
          name: 'proList',
          component: proList,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'mySubsidy',
          name: 'mySubsidy',
          component: mySubsidy,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'myRight',
          name: 'myRight',
          component: myRight,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'myMessage',
          name: 'myMessage',
          component: myMessage,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'organizationIndex',
          name: 'organizationIndex',
          component: organizationIndex,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'serviceOrg',
          name: 'serviceOrg',
          component: serviceOrg,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'companyOrg',
          name: 'companyOrg',
          component: companyOrg,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'myTraining',
          name: 'myTraining',
          component: myTraining,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'myTrainingAdd',
          name: 'myTrainingAdd',
          component: myTrainingAdd,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'myTrainingDetail',
          name: 'myTrainingDetail',
          component: myTrainingDetail,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'myDemands',
          name: 'myDemands',
          component: myDemands,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'myDemandsAdd',
          name: 'myDemandsAdd',
          component: myDemandsAdd,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'companyProductList',
          name: 'companyProductList',
          component: companyProductList,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'myDemandsDetail',
          name: 'myDemandsDetail',
          component: myDemandsDetail,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'myService',
          name: 'myService',
          component: myService,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'myServiceAdd',
          name: 'myServiceAdd',
          component: myServiceAdd,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        }, {
          path: 'myServiceDetail',
          name: 'myServiceDetail',
          component: myServiceDetail,
          meta: {
            title: '遂企云•个人中心',
            authKey: true,
          },
        },
      ],
    }, {
      path: '/news',
      name: 'news',
      component: routeConrtainer,
      children: [
        {
          path: 'newsIndex',
          name: 'newsIndex',
          component: newsIndex,
          meta: {
            title: '资讯云',
          },
        }, {
          path: 'newsDetail',
          name: 'newsDetail',
          component: newsDetail,
          meta: {
            title: '资讯云',
          },
        }, {
          path: 'newsSearch',
          name: 'newsSearch',
          component: newsSearch,
          meta: {
            title: '资讯云',
          },
        }, {
          path: 'newsType',
          name: 'newsType',
          component: newsType,
          meta: {
            title: '资讯云',
          },
        },
      ],
    }, {
      path: '/policy',
      name: 'policy',
      component: routeConrtainer,
      children: [
        {
          path: 'policyIndex',
          name: 'policyIndex',
          component: policyIndex,
          meta: {
            title: '政策云',
          },
        }, {
          path: 'policyType',
          name: 'policyType',
          component: policyType,
          meta: {
            title: '政策云',
          },
        }, {
          path: 'policyDetail',
          name: 'policyDetail',
          component: policyDetail,
          meta: {
            title: '政策云',
          },
        }, {
          path: 'policyEngine',
          name: 'policyEngine',
          component: policyEngine,
          meta: {
            title: '政策云',
          },
        }, {
          path: 'policyApply',
          name: 'policyApply',
          component: policyApply,
          meta: {
            title: '政策云',
          },
        }, {
          path: 'policyList',
          name: 'policyList',
          component: policyList,
          meta: {
            title: '政策云',
          },
        }, {
          path: 'applyEnter',
          name: 'applyEnter',
          component: applyEnter,
          meta: {
            title: '政策云',
          },
        }, {
          path: 'serviceSubsidy',
          name: 'serviceSubsidy',
          component: serviceSubsidy,
          meta: {
            title: '服务补贴',
          },
        }, {
          path: 'subsidyDetail',
          name: 'subsidyDetail',
          component: subsidyDetail,
          meta: {
            title: '服务补贴',
          },
        }, {
          path: 'subsidyApply',
          name: 'subsidyApply',
          component: subsidyApply,
          meta: {
            title: '服务补贴',
          },
        },
      ],
    },
    {
      path: '/service',
      name: 'service',
      component: routeConrtainer,
      children: [
        {
          path: 'serviceIndex',
          name: 'serviceIndex',
          component: serviceIndex,
          meta: {
            title: '服务云',
          },
        }, {
          path: 'serviceOrgList',
          name: 'serviceOrgList',
          component: serviceOrgList,
          meta: {
            title: '服务机构',
          },
        }, {
          path: 'serviceOrgDetail',
          name: 'serviceOrgDetail',
          component: serviceOrgDetail,
          meta: {
            title: '服务机构',
          },
        }, {
          path: 'serviceType',
          name: 'serviceType',
          component: serviceType,
          meta: {
            title: '服务云',
          },
        }, {
          path: 'serviceUnit',
          name: 'serviceUnit',
          component: serviceUnit,
          meta: {
            title: '服务云',
          },
        }, {
          path: 'serviceDetail',
          name: 'serviceDetail',
          component: serviceDetail,
          meta: {
            title: '服务云',
          },
        }, {
          path: 'serviceApply',
          name: 'serviceApply',
          component: serviceApply,
          meta: {
            title: '服务云',
          },
        }, {
          path: 'demandsIndex',
          name: 'demandsIndex',
          component: demandsIndex,
          meta: {
            title: '服务云',
          },
        }, {
          path: 'demandsType',
          name: 'demandsType',
          component: demandsType,
          meta: {
            title: '服务云',
          },
        }, {
          path: 'demandsDetail',
          name: 'demandsDetail',
          component: demandsDetail,
          meta: {
            title: '服务云',
          },
        }, {
          path: 'demandsUnit',
          name: 'demandsUnit',
          component: demandsUnit,
          meta: {
            title: '服务云',
          },
        }, {
          path: 'demandsAdd',
          name: 'demandsAdd',
          component: demandsAdd,
          meta: {
            title: '服务云',
          },
        },
      ],
    },
    {
      path: '/training',
      name: 'training',
      component: routeConrtainer,
      children: [
        {
          path: 'trainingIndex',
          name: 'trainingIndex',
          component: trainingIndex,
          meta: {
            title: '培训云',
          },
        },
        {
          path: 'trainingAdd',
          name: 'trainingAdd',
          component: trainingAdd,
          meta: {
            title: '培训云',
          },
        },
        {
          path: 'trainingSearch',
          name: 'trainingSearch',
          component: trainingSearch,
          meta: {
            title: '培训云',
          },
        },
        {
          path: 'trainingOrg',
          name: 'trainingOrg',
          component: trainingOrg,
          meta: {
            title: '培训云',
          },
        },
        {
          path: 'trainingDetail',
          name: 'trainingDetail',
          component: trainingDetail,
        },
      ],
    },
    {
      path: '/industry',
      name: 'industry',
      component: routeConrtainer,
      children: [
        {
          path: 'industryIndex',
          name: 'industryIndex',
          component: industryIndex,
          meta: {
            title: '产融云',
          },
        },
        {
          path: 'financingProducts',
          name: 'financingProducts',
          component: financingProducts,
          meta: {
            title: '产融云',
          },
        },
        {
          path: 'financingProductsDetail',
          name: 'financingProductsDetail',
          component: financingProductsDetail,
          meta: {
            title: '产融云',
          },
        },
        {
          path: 'loanService',
          name: 'loanService',
          component: loanService,
          meta: {
            title: '产融云',
          },
        },
        {
          path: 'enterpriseProject',
          name: 'enterpriseProject',
          component: enterpriseProject,
          meta: {
            title: '产融云',
          },
        },
      ],
    },
    {
      path: '/innovation',
      name: 'innovation',
      component: routeConrtainer,
      children: [
        {
          path: 'innovationIndex',
          name: 'innovationIndex',
          component: innovationIndex,
          meta: {
            title: '创新云',
          },
        }, {
          path: 'achievement',
          name: 'achievement',
          component: achievement,
          meta: {
            title: '创新云',
          },
        }, {
          path: 'achievementDetail',
          name: 'achievementDetail',
          component: achievementDetail,
          meta: {
            title: '创新云',
          },
        }, {
          path: 'patent',
          name: 'patent',
          component: patent,
          meta: {
            title: '创新云',
          },
        }, {
          path: 'patentAdd',
          name: 'patentAdd',
          component: patentAdd,
          meta: {
            title: '创新云',
          },
        }, {
          path: 'patentDetail',
          name: 'patentDetail',
          component: patentDetail,
          meta: {
            title: '创新云',
          },
        }, {
          path: 'patentRightDetail',
          name: 'patentRightDetail',
          component: patentRightDetail,
          meta: {
            title: '创新云',
          },
        }, {
          path: 'rightsProtection',
          name: 'rightsProtection',
          component: rightsProtection,
          meta: {
            title: '创新云',
          },
        },
      ],
    },
    {
      path: '/thinkTank',
      name: 'thinkTank',
      component: routeConrtainer,
      children: [
        {
          path: 'thinkTankIndex',
          name: 'thinkTankIndex',
          component: thinkTankIndex,
          meta: {
            title: '智库云',
          },
        }, {
          path: 'expert',
          name: 'expert',
          component: expert,
          meta: {
            title: '智库云',
          },
        }, {
          path: 'institution',
          name: 'institution',
          component: institution,
          meta: {
            title: '智库云',
          },
        }, {
          path: 'institutionOrgDetail',
          name: 'institutionOrgDetail',
          component: institutionOrgDetail,
          meta: {
            title: '智库云',
          },
        }, {
          path: 'tutor',
          name: 'tutor',
          component: tutor,
          meta: {
            title: '智库云',
          },
        }, {
          path: 'expertDetail',
          name: 'expertDetail',
          component: expertDetail,
          meta: {
            title: '智库云',
          },
        },
      ],
    },
    {
      path: '/company',
      name: 'company',
      component: routeConrtainer,
      children: [
        {
          path: 'companyIndex',
          name: 'companyIndex',
          component: companyIndex,
          meta: {
            title: '企业云',
          },
        }, {
          path: 'orgDetail',
          name: 'orgDetail',
          component: orgDetail,
          meta: {
            title: '遂企云',
          },
        },
        {
          path: 'productDetail',
          name: 'productDetail',
          component: productDetail,
          meta: {
            title: '遂企云',
          },
        },
      ],
    },
    {
      path: '/organization',
      name: 'organization',
      component: routeConrtainer,
      children: [
        {
          path: 'organizationIndex',
          name: 'organizationIndex2',
          component: organizationIndex,
          meta: {
            title: '遂企云',
          },
        }, {
          path: 'serviceOrg',
          name: 'serviceOrg2',
          component: serviceOrg,
          meta: {
            title: '遂企云',
            authKey: true,
          },
        },
        {
          path: 'companyOrg',
          name: 'companyOrg2',
          component: companyOrg,
          meta: {
            title: '遂企云',
          },
        }, {
          path: 'orgUserList',
          name: 'orgUserList',
          component: orgUserList,
          meta: {
            title: '遂企云',
          },
        },
      ],
    },
    {
      path: '/zhaobiao',
      name: zhaobiao,
      component: routeConrtainer,
      children: [
        {
          path: 'list',
          name: 'zhaobiaoIndex',
          component: zhaobiao,
          meta: {
            title: '招投标信息',
            authKey: true,
          },
        },
        {
          path: 'detail',
          name: 'zhaobiaoDetail',
          component: zhaobiaoDetail,
          meta: {
            title: '招投标信息',
            authKey: true,
          },
        }
      ]
    },
    {
      path: '/subsidyReport',
      name: 'subsidyReport',
      component: routeConrtainer,
      children: [
        {
          path: 'subsidyReportList',
          name: 'subsidyReportList',
          component: subsidyReportList,
          meta: {
            authKey: true,
          },
        }, {
          path: 'subsidyApplyReportList',
          name: 'subsidyApplyReportList',
          component: subsidyApplyReportList,
          meta: {
            authKey: true,
          },
        }, {
          path: 'subsidyReportDetail',
          name: 'subsidyReportDetail',
          component: subsidyReportDetail,
          meta: {
            authKey: true,
          },
        },
      ]
    },
    {
      path: '/yq',
      name: 'yq',
      component: routeConrtainer,
      children: [
        {
          path: 'yqpolicy',
          name: 'yqpolicy',
          component: yqpolicy,
          meta: {
            authKey: false,
          },
        }, {
          path: 'zhunwu',
          name: 'zhunwu',
          component: zhunwu,
          meta: {
            authKey: false,
          },
        }, {
          path: 'zwDetail',
          name: 'zwDetail',
          component: zwDetail,
          meta: {
            authKey: false,
          },
        }, {
          path: 'yqDetail',
          name: 'yqDetail',
          component: yqDetail,
          meta: {
            authKey: false,
          },
        }, {
          path: 'yqServer',
          name: 'yqServer',
          component: yqServer,
          meta: {
            authKey: false,
          },
        }, {
          path: 'yqNeed',
          name: 'yqNeed',
          component: yqNeed,
          meta: {
            authKey: false,
          },
        }, {
          path: 'yqNeedDetail',
          name: 'yqNeedDetail',
          component: yqNeedDetail,
          meta: {
            authKey: false,
          },
        }, {
          path: 'yqLive',
          name: 'yqLive',
          component: yqLive,
          meta: {
            authKey: false,
          },
        }, {
          path: 'yqZJ',
          name: 'yqZJ',
          component: yqZJ,
          meta: {
            authKey: false,
          },
        }, {
          path: 'yqTips',
          name: 'yqTips',
          component: yqTips,
          meta: {
            authKey: false,
          },
        }, {
          path: 'yqTipDetail',
          name: 'yqTipDetail',
          component: yqTipDetail,
          meta: {
            authKey: false,
          },
        }
      ]}
  ],
})
router.beforeEach((to, from, next) => {
  if (_hmt) { // 创建vuerouter后，调用beforeEach方法，每个路由跳转时都将其跳转的路由推给百度。
    if (to.path) {
      _hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }

  if (to.meta.title) {
    document.title = to.meta.title // 在路由里面写入的meta里面的title字段serviceDetail
  } else {
    document.title = '遂企云'
  }
  if (to.name !== 'compatible' && utils.getIEVersion() <= 9) {
    next({
      name: 'compatible',
    })
  }
  if (to.meta.authKey) {
    let u = WebStorage.getItem('userInfo_sn') || null
    console.log(u)
    if (u) {
      API.account.checkAuthkey({ authKey: u.authKey }, (da) => {
        if (da.status) {
          next()
        } else {
          next({
            path: '/signin',
            query: {
              backUrl: to.fullPath,
            }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
          })
        }
      })
    } else {
      next({
        path: '/signin',
        query: {
          backUrl: to.fullPath,
        }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }
  next()
})
// 路由切换时回到页面顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js